// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {map} from 'lodash';

// Components
import MultiSelect from '../core/multi-select';
import Select from '../core/select';

// Data
import languageMap from '../../bootstrap-data/language-map';

function LanguageSelect(props) {
    const {defaultOption, noMulti} = props;

    const getClass = () => {
        const {className} = props;

        return classnames('language-select', className);
    };

    const getMultiProps = () => {
        const options = map(languageMap, (value, key) => ({
            value: key,
            label: value.name,
        }));

        return {
            ...props,
            className: getClass(),
            options,
            multi: true,
            operator: '=in=',
            placeholder: 'Filter by Language',
        };
    };

    const getProps = () => ({
        ...props,
        className: getClass(),
    });

    const renderMultiSelect = () => <MultiSelect {...getMultiProps()} />;

    const renderSelect = () => (
        <Select {...getProps()}>
            {defaultOption ? <option value="">{defaultOption}</option> : null}
            {map(languageMap, ({name}, code) => (
                <option key={code} value={code}>
                    {name}
                </option>
            ))}
        </Select>
    );

    return !noMulti ? renderMultiSelect() : renderSelect();
}

LanguageSelect.propTypes = {
    className: PropTypes.string,
    defaultOption: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    noMulti: PropTypes.bool,
    submitOnChange: PropTypes.bool,
    validate: PropTypes.array,
};

export default LanguageSelect;
